module.exports = __webpack_public_path__ + "img/3.4c9f9028.jpg";